import {takeEvery} from 'redux-saga/effects'

import {
  ADD_GRADE,
  DELETE_GRADE,
  DELETE_MANY_GRADES,
  GET_GRADE,
  GET_GRADES,
  GET_SUBJECTS_GRADES,
  GET_SUBJECT_GRADES,
  GET_TEACHER_CLASS_GRADES,
  INACTIVATE_GRADE,
  REDUX_GET_GRADES,
  UPDATE_GRADE,
  UPDATE_GRADES_SEQUENCE,
} from '../../../Actions/School/Grade/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_GRADES, fetchData)
  yield takeEvery(GET_GRADE, fetchData)
  yield takeEvery(DELETE_GRADE, fetchData)
  yield takeEvery(INACTIVATE_GRADE, fetchData)
  yield takeEvery(ADD_GRADE, fetchData)
  yield takeEvery(DELETE_MANY_GRADES, fetchData)
  yield takeEvery(UPDATE_GRADE, fetchData)
  yield takeEvery(REDUX_GET_GRADES, fetchData)
  yield takeEvery(GET_SUBJECT_GRADES, fetchData)
  yield takeEvery(UPDATE_GRADES_SEQUENCE, fetchData)
  yield takeEvery(GET_SUBJECTS_GRADES, fetchData)
  yield takeEvery(GET_TEACHER_CLASS_GRADES, fetchData)
}

export default dataSaga
